import { clsx } from 'clsx'
import { XMarkIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid'
import { Button } from '~/components'
import { getGlobal, getLinkType } from '~/utils'
import { Link } from '@remix-run/react'

import type { SanityNavItem } from '~/types'

interface Props {
  open: boolean
  items: SanityNavItem[]
  setOpen: (e: boolean) => void
}

const OffcanvasNav = ({ open, items, setOpen }: Props) => {
  const { site } = getGlobal()
  return (
    <div
      className={clsx(
        'fixed -right-full top-0 z-50 flex h-dvh w-full flex-col overflow-y-auto bg-teal-700 shadow-md transition-transform duration-500 xl:hidden',
        {
          '-translate-x-full': open,
        }
      )}
    >
      <div className="flex items-center justify-between bg-teal-700 px-8 py-8">
        {site?.global?.logo?.asset?.url && (
          <img
            className="max-h-8"
            src={site.global.logo.asset.url}
            alt={site.global.logo?.alt}
          />
        )}
        <button
          className="flex size-10 items-center justify-center"
          onClick={() => setOpen(false)}
        >
          <XMarkIcon className="size-10 text-white" />
        </button>
      </div>
      <div className="flex flex-col gap-8 px-8">
        {items &&
          items.map((item, i) => {
            const { linkType, linkReference, linkSlug, linkExternal } = item
            const link = getLinkType({
              linkType,
              linkReference,
              linkSlug,
              linkExternal,
            })
            return (
              <Link
                key={i}
                className="text-2xl text-white"
                to={link}
                onClick={() => setOpen(false)}
              >
                {item.title}
              </Link>
            )
          })}
        {site.global.phoneNumber && (
          <Link
            onClick={() => setOpen(false)}
            to={`tel:${site?.global?.phoneNumber}`}
            className="flex items-center gap-2 text-2xl text-white"
          >
            <PhoneIcon className="size-6" />
            {site.global.phoneNumber}
          </Link>
        )}
        {site.global.emailAddress && (
          <Link
            onClick={() => setOpen(false)}
            to={`mailto:${site?.global?.emailAddress}`}
            className="flex items-center gap-2 text-2xl text-white"
          >
            <EnvelopeIcon className="size-6" />
            {site.global.emailAddress}
          </Link>
        )}
        {site.global.buttons &&
          site.global.buttons.map(
            (button, i) =>
              button.linkSlug && (
                <Link
                  className={clsx(
                    'border px-8 py-3 text-center text-beige-200 hover:text-beige-200',
                    {
                      'border-transparent bg-gold-500 hover:border-gold-300 hover:bg-gold-300':
                        button.style === 'gold',
                      'border-beige-200 bg-transparent hover:border-gold-300 hover:bg-gold-300':
                        button.style === 'whiteOutline',
                    }
                  )}
                  key={i}
                  to={button.linkSlug}
                  onClick={() => setOpen(false)}
                >
                  {button.title}
                </Link>
              )
          )}
      </div>
    </div>
  )
}

export default OffcanvasNav
